module.exports = __webpack_public_path__ + "img/lyx.65d2b09a.jpg";